import { useEffect } from "react";
import { useBlocker } from "react-router-dom";
const PROMPT_MESSAGE = "Leave site?\nChanges you made may not be saved.";
/**
 * Used to prevent the user from navigating away from a page
 *
 * [Example from react-router-dom docs ](https://github.com/remix-run/react-router/tree/dev/examples/navigation-blocking)
 * @param when
 * @returns
 */
export const Prompt = ({ when, optionalMessage }) => {
    const blocker = useBlocker(when);
    useEffect(() => {
        //This is called when navigating inside of the react app (e.g. Clicking a nav item in the header)
        if (blocker.state === "blocked") {
            if (confirm(optionalMessage ? optionalMessage : PROMPT_MESSAGE)) {
                blocker.proceed();
            }
            else {
                blocker.reset();
            }
        }
        //This is called when navigating outside of the react app (e.g. Refreshing the page or going to a new url)
        if (when) {
            window.onbeforeunload = (e) => {
                e.preventDefault();
                return "onbeforeunload";
            };
            return () => {
                window.onbeforeunload = null;
            };
        }
    });
    return null;
};
